/** Header set by middleware identifying which Cognito pool authenticated the request. */
export const AUTH_POOL_HEADER = 'x-tai-auth-pool';

export type AuthPool = 'customer' | 'employee';

/**
 * Which pool's session (and therefore which idle clock) a surface belongs to.
 *
 * Resolved from the path, not from cookies: pool lookups fall back to the employee
 * pool only when no customer session exists, and a CSM has both — so without this the
 * employee pool is never selected while `/employee/*` is in use. That is what froze
 * the employee stamp (`SessionMount` heartbeats, lib/session/constants.ts) and what
 * made the proxy idle-check the wrong clock (`poolOrderForRequest`, proxy.ts).
 *
 * Lives here rather than next to either caller because both the client shell and the
 * proxy have to agree on it — a route the two disagree about is a route whose clock
 * is stamped by one pool and enforced against the other.
 */
export function poolForRoute(pathname: string): AuthPool {
    return pathname === '/employee' || pathname.startsWith('/employee/')
        ? 'employee'
        : 'customer';
}
